import axios from 'axios';

import {
    CREATE_EMPLOYEE_REQUEST,
    CREATE_EMPLOYEE_SUCCESS,
    CREATE_EMPLOYEE_FAIL,
    CHANGE_EMPLOYEE_REQUEST,
    CHANGE_EMPLOYEE_SUCCESS,
    CHANGE_EMPLOYEE_FAIL,
    GET_EMPLOYEES_REQUEST,
    GET_EMPLOYEES_SUCCESS,
    GET_EMPLOYEES_FAIL,
    CHANGE_EMPLOYEE_RESET,
    CREATE_EMPLOYEE_RESET
} from '../constants/employeeConstants';

export const getEmployees = () => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: GET_EMPLOYEES_REQUEST,
        });

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URI}/employees`, config);

        dispatch({
            type: GET_EMPLOYEES_SUCCESS,
            payload: data
        });
    } catch (error) {
        dispatch({
            type: GET_EMPLOYEES_FAIL,
            payload: 'An error Occurred'
        });
    }
};

export const activateDeactivateEmployee = (id) => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: CHANGE_EMPLOYEE_REQUEST
        });

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.put(`${process.env.REACT_APP_BACKEND_URI}/employees/${id}`, {}, config);

        dispatch({
            type: CHANGE_EMPLOYEE_SUCCESS,
            payload: data,
        });

        dispatch({ type: CHANGE_EMPLOYEE_RESET });
    } catch (error) {
        dispatch({
            type: CHANGE_EMPLOYEE_FAIL,
            payload: 'An error Occurred'
        });
    }
};

export const createNewEmployee = (name, contact) => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: CREATE_EMPLOYEE_REQUEST
        });

        const formData = {
            name,
            contact
        }

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/employees`, formData, config);

        dispatch({
            type: CREATE_EMPLOYEE_SUCCESS,
            payload: data,
        });

        dispatch({ type: CREATE_EMPLOYEE_RESET });

    } catch (error) {
        dispatch({
            type: CREATE_EMPLOYEE_FAIL,
            payload: 'An error Occurred'
        });
    }
};